import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.625rem"
      height="1.25rem"
      viewBox="0 0 26 20"
      version="1.1">
      <title>noun-images-7154767</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Right-hand-vhc-tools"
          transform="translate(-17, -142)"
          fill="#54617A"
          fillRule="nonzero">
          <g id="noun-images-7154767" transform="translate(17.0005, 142)">
            <path
              d="M25.2,0 L2,0 C1.77900032,0 1.6,0.17900032 1.6,0.4 L1.6,1.6 L0.4,1.6 C0.17900032,1.6 0,1.77900032 0,2 L0,19.6 C0,19.8209997 0.17900032,20 0.4,20 L23.6,20 C23.8209997,20 24,19.8209997 24,19.6 L24,18.4 L25.2,18.4 C25.4209997,18.4 25.6,18.2209997 25.6,18 L25.6,0.4 C25.6,0.17900032 25.4209997,0 25.2,0 L25.2,0 Z M23.2,19.2 L0.8,19.2 L0.8,2.4 L1.6,2.4 L1.6,18.000128 C1.6,18.2211277 1.77900032,18.400128 2,18.400128 L23.2,18.400128 L23.2,19.2 Z M24.8,17.6 L2.4,17.6 L2.4,0.8 L24.8,0.8 L24.8,17.6 Z"
              id="Shape"
            />
            <path
              d="M3.599744,16.799744 L23.599744,16.799744 C23.8207437,16.799744 23.999744,16.6207437 23.999744,16.399744 L23.999744,1.999744 C23.999744,1.77874432 23.8207437,1.599744 23.599744,1.599744 L3.599744,1.599744 C3.37874432,1.599744 3.199744,1.77874432 3.199744,1.999744 L3.199744,16.399744 C3.199744,16.6207437 3.37874432,16.799744 3.599744,16.799744 Z M3.999744,15.999744 L3.999744,12.58368 L9.19168,8.133632 L13.329664,11.895552 C13.481664,12.0335514 13.7156608,12.0335514 13.8676736,11.895552 L18.0056576,8.133632 L23.1975936,12.58368 L23.1975936,15.999744 L3.999744,15.999744 Z M23.199744,2.399744 L23.199744,11.529728 L18.259712,7.295744 C18.106711,7.16474368 17.8797056,7.167744 17.7297152,7.303744 L13.5986432,11.059776 L9.4675712,7.303744 C9.31757056,7.167744 9.0915584,7.16474368 8.9375744,7.295744 L3.9975424,11.529728 L3.99954227,2.399744 L23.199744,2.399744 Z"
              id="Shape"
            />
            <path
              d="M13.599872,7.199744 C14.4818688,7.199744 15.199872,6.4817408 15.199872,5.599744 C15.199872,4.7177472 14.4818688,3.999744 13.599872,3.999744 C12.7178752,3.999744 11.999872,4.7177472 11.999872,5.599744 C11.999872,6.4817408 12.7178752,7.199744 13.599872,7.199744 Z M13.599872,4.799744 C14.0408832,4.799744 14.399872,5.1587328 14.399872,5.599744 C14.399872,6.0407552 14.0408832,6.399744 13.599872,6.399744 C13.1588608,6.399744 12.799872,6.0407552 12.799872,5.599744 C12.799872,5.1587328 13.1588608,4.799744 13.599872,4.799744 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
